import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KeyboardKey } from '@standardnotes/ui-services';
import { useCallback, useRef } from 'react';
import SearchOptions from '@/Components/SearchOptions/SearchOptions';
import Icon from '../Icon/Icon';
import DecoratedInput from '../Input/DecoratedInput';
import { observer } from 'mobx-react-lite';
import ClearInputButton from '../ClearInputButton/ClearInputButton';
import { ElementIds } from '@/Constants/ElementIDs';
import { classNames } from '@standardnotes/snjs';
const SearchBar = ({ itemListController, searchOptionsController, hideOptions = false }) => {
    const searchBarRef = useRef(null);
    const searchInputRef = useRef(null);
    const { noteFilterText, setNoteFilterText, clearFilterText, onFilterEnter } = itemListController;
    const onNoteFilterTextChange = useCallback((text) => {
        setNoteFilterText(text);
    }, [setNoteFilterText]);
    const onNoteFilterKeyUp = useCallback((e) => {
        if (e.key === KeyboardKey.Enter) {
            onFilterEnter();
        }
    }, [onFilterEnter]);
    const onClearSearch = useCallback(() => {
        var _a;
        clearFilterText();
        (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [clearFilterText]);
    return (_jsxs("div", { className: "group pb-0.5 pt-3", role: "search", ref: searchBarRef, children: [_jsx(DecoratedInput, { autocomplete: false, id: ElementIds.SearchBar, className: {
                    container: 'px-1',
                    input: 'text-base placeholder:text-passive-0 lg:text-sm',
                }, placeholder: 'Search...', value: noteFilterText, ref: searchInputRef, onChange: onNoteFilterTextChange, onKeyUp: onNoteFilterKeyUp, left: [_jsx(Icon, { type: "search", className: "mr-1 h-4.5 w-4.5 flex-shrink-0 text-passive-1" })], right: [noteFilterText && _jsx(ClearInputButton, { onClick: onClearSearch })], roundedFull: true }), _jsx("div", { className: classNames('animate-fade-from-top', hideOptions ? 'hidden' : !noteFilterText && 'hidden group-focus-within:flex'), children: _jsx(SearchOptions, { searchOptions: searchOptionsController }) })] }));
};
export default observer(SearchBar);
